import { usePermissionContext } from "../contexts/PermissionContext";

/**
 * RBAC helpers for the signed-in user (from access-summary + JWT hints).
 *
 * @returns {{
 *   can: (resource: string, action?: string) => boolean;
 *   canAny: (checks: [string, string][]) => boolean;
 *   canAll: (checks: [string, string][]) => boolean;
 *   summary: object|null;
 *   loading: boolean;
 *   error: unknown;
 *   refresh: () => Promise<void>;
 *   bypass: boolean;
 *   isStaff: boolean;
 *   accessibleStores: string[];
 *   accessibleBranches: string[];
 * }}
 */
export function usePermission() {
  const {
    can,
    canAny,
    canAll,
    summary,
    loading,
    error,
    refresh,
    bypass,
    isStaff,
    accessibleStores,
    accessibleBranches,
  } = usePermissionContext();

  return {
    can,
    canAny,
    canAll,
    summary,
    loading,
    error,
    refresh,
    bypass,
    isStaff,
    accessibleStores,
    accessibleBranches,
  };
}
